/**
 * SearchButton
 * 
 * @Author: Focci
 * @Date: 2023-09-29 17:04:32
 * @Last Modified by: Focci
 * @Last Modified time: 2023-09-29 17:04:32
 */

import PropTypes from 'prop-types'
import { Button } from '@comp/material'
import { useTranslations } from 'next-intl'

export default function SearchButton({
  fontSize = '.9rem',
  paddingX = '1.2rem',
  ...buttonProps
}) {
  const ts = useTranslations('search')
  return (
    <Button 
      sx={{
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        fontSize,
        pl: paddingX,
        pr: paddingX,
      }}
      {...buttonProps}
    >
      {ts('search')}
    </Button>
  )
}

SearchButton.propTypes = {
  fontSize: PropTypes.string,
  paddingX: PropTypes.string,
}
